import { useTrackingActions } from './use-tracking-actions';
export function useTimelineActions() {
  var trackingActions = useTrackingActions();
  return trackingActions;
}